import { combineReducers } from 'redux';
import sidebarReducer from './sidebarReducer';
import dashboardReducer from './dashboardReducer';
import notificacionesReducer from './notificacionesReducer';
import publicacionesReducer from './publicacionesReducer';
import ordenesReducer from './ordenesReducer';
import generalReducer from './generalReducer';
import sellersReducer from './sellersReducer';
import usuariosReducer from './usuariosReducer';
import planesReducer from './planesReducer';
import tiposReducer from './tiposReducer';
import tiposPublicacionReducer from './tiposPublicacionReducer';
import liquidacionesReducer from './liquidacionesReducer';
import rebatesReducer from './rebatesReducer';
import busquedaGlobalReducer from './busquedaGlobalReducer';

export default combineReducers({
    sidebar: sidebarReducer,
    dashboard: dashboardReducer,
    notificaciones: notificacionesReducer,
    publicaciones: publicacionesReducer,
    ordenes: ordenesReducer,
    general: generalReducer,
    sellers: sellersReducer,
    usuarios: usuariosReducer,
    planes: planesReducer,
    tipos: tiposReducer,
    tiposPublicacion: tiposPublicacionReducer,
    liquidaciones: liquidacionesReducer,
    rebates: rebatesReducer,
    busquedaGlobal: busquedaGlobalReducer
})